"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorHandle = exports.Application = void 0;
const ReactDOM = require("react-dom");
const simple_master_page_1 = require("./masters/simple-master-page");
const main_master_page_1 = require("./masters/main-master-page");
const React = require("react");
const my_service_1 = require("./services/my-service");
const chitu_react = __importStar(require("maishu-chitu-react"));
const ui = __importStar(require("maishu-ui-toolkit"));
const maishu_ui_toolkit_1 = require("maishu-ui-toolkit");
let app = null;
async function startup(requirejs) {
    console.assert(requirejs != null);
    async function createMasterPages(app) {
        let mainProps = { app };
        let simplePorps = { app };
        let r = await Promise.all([
            renderElement(simple_master_page_1.SimpleMasterPage, simplePorps, document.getElementById('simple-master')),
            renderElement(main_master_page_1.MainMasterPage, mainProps, document.getElementById('main-master')),
        ]);
        return {
            simple: r[0],
            default: r[1]
        };
    }
    app = new Application(requirejs, document.getElementById('simple-master'), document.getElementById('main-master'), document.getElementById('blank-master'));
    let service = app.createService(my_service_1.MyService);
    let config = await service.config();
    maishu_ui_toolkit_1.Less.renderByRequireJS("admin_style_default");
    console.assert(config.menuItems != null);
    let masterPages = await createMasterPages(app);
    masterPages.default.setMenu(...config.menuItems);
    requirejs(["clientjs_init.js"], function (initModule) {
        console.assert(masterPages.default != null);
        if (initModule && typeof initModule.default == 'function') {
            let args = {
                app, mainMaster: masterPages.default, requirejs
            };
            let result = initModule.default(args);
            if (result != null && result.then != null) {
                result.then(() => {
                    app.run();
                });
                return;
            }
        }
        app.run();
    });
}
exports.default = startup;
function renderElement(componentClass, props, container) {
    return new Promise((resolve) => {
        props.ref = function (e) {
            if (!e)
                return;
            resolve(e);
        };
        let element = React.createElement(componentClass, props);
        ReactDOM.render(element, container);
    });
}
class Application extends chitu_react.Application {
    constructor(requirejs, simpleContainer, mainContainer, blankContainer) {
        super({
            container: {
                simple: simpleContainer,
                default: mainContainer,
                blank: blankContainer,
            }
        });
        this.error.add((sender, error) => errorHandle(error, this));
        this.pageCreated.add((sender, page) => this.onPageCreated(page));
    }
    async onPageCreated(page) {
        // let lessFilePath: string;
        // if (page.name.indexOf(":")) {
        //     let arr = page.name.split(":");
        //     lessFilePath = `modules/${arr[1]}.less`;
        // }
        // else {
        //     lessFilePath = `modules/${page.name}.less`;
        // }
        // lessFilePath = `${page.name}.less`;
        let pageClassName = page.name.split("/").filter(o => o != "").join("-");
        page.element.className = `admin-page ${pageClassName}`;
        // let stationPath = getStationPath(page.name);
        // let myService = this.createService(MyService);
        // let files = await myService.files(stationPath);
        // let pageLessFiles = files.filter(o => o.startsWith("modules") && o.endsWith(".less"));
        // if (pageLessFiles.indexOf(lessFilePath) >= 0) {
        //     this.loadPageLess(lessFilePath, pageClassName, stationPath);
        // }
    }
}
exports.Application = Application;
let errorMessages = {
    "726": "没有权限访问"
};
function errorHandle(error, app) {
    error.message = errorMessages[error.name] || error.message;
    if (error.name == "718" && app != null) {
        // app.redirect("login");
        location.hash = "#login";
        return;
    }
    ui.alert({
        title: "错误",
        message: error.message
    });
}
exports.errorHandle = errorHandle;
